import React from "react";
import { IoMdClose } from "react-icons/io";
import Lang from "../Lang";
import NavbarMobileList from "./NavbarMobileList";
import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import Link from "next/link";

type TNavbarMobileSidebarProps = {
  toggleSidebar: () => void;
};

const NavbarMobileSidebar = ({ toggleSidebar }: TNavbarMobileSidebarProps) => {
  const t = useTranslations();

  return (
    <div className="fixed top-0 left-0 bg-white dark:bg-input  p-6 z-[100] w-full h-screen overflow-y-scroll snap-y snap-mandatory scrollbar-hide dark:scrollbar dark:scrollbar-track-transparent dark:scrollbar-thumb-white dark:scrollbar-thumb-rounded dark:scrollbar-track-rounded">
      <div className="flex items-center justify-between">
        <IoMdClose
          onClick={toggleSidebar}
          className="text-3xl cursor-pointer hover:text-primary transition-all duration-200"
        />
        {/* LANGUAGES */}
        <Lang />
      </div>

      {/* NAVBAR */}
      <NavbarMobileList toggleSidebar={toggleSidebar} />

      <div className="flex items-center justify-center">
        <Button
          onClick={toggleSidebar}
          aria-label={t("Hire Me")}
          className="w-full md:w-[60%] lg:w-[50%]"
        >
          <Link href="/#Contact">{t("Hire Me")}</Link>
        </Button>
      </div>
    </div>
  );
};

export default NavbarMobileSidebar;
